import { render } from "./report-detail.vue?vue&type=template&id=972c2d62&scoped=true&ts=true"
import script from "./report-detail.vue?vue&type=script&lang=ts"
export * from "./report-detail.vue?vue&type=script&lang=ts"

import "./report-detail.vue?vue&type=style&index=0&id=972c2d62&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-972c2d62"]])

export default __exports__